import React, { ReactNode, useEffect } from 'react';
import { useAppSelector, useThunkDispatch } from '../../hooks/redux';

import { Route } from 'react-router-dom';
import checkLogin from '../../actions/setters/checkLogin';
import useRedirectToLogin from '../../hooks/useRedirectToLogin';

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  exact,
  path,
}) => {
  const dispatch = useThunkDispatch();
  const redirectToLogin = useRedirectToLogin();
  const isLoggedIn = useAppSelector(state => state.app.loginStatus.isLoggedIn);

  useEffect(() => {
    dispatch(checkLogin()).catch(() => {
      redirectToLogin();
    });
  }, []); // eslint-disable-line

  return (
    <Route
      exact={exact}
      path={path}
      render={() => (isLoggedIn ? children : null)}
    />
  );
};

export interface PrivateRouteProps {
  children: ReactNode;
  path?: string;
  exact?: boolean;
}
